import { AuthenticatedRequestHandler, IAuthenticatedRequestHandlerResponse } from '@api/utils/AuthenticatedRequestHandler'
import StoreSelectionClient from 'IhmStoreSelectionServiceLambda-coral-javascript-clients/jquery-client'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'

export class StoreSelectionServiceClient {
    private static instance: StoreSelectionClient
    private readonly client: any
    private readonly endpoint: string

    public static getInstance (): StoreSelectionServiceClient {
        if (!StoreSelectionServiceClient.instance) {
            StoreSelectionServiceClient.instance = new StoreSelectionServiceClient()
        }
        return StoreSelectionServiceClient.instance
    }

    /**
     * Returns list of nearby store's info.
     *
     * @param {string} storeId
     * @return {Promise} Store info. For example.
     *  [
     *    {
     *       "storeId": "US-WA-20",
     *       "name": "Madison & Minor",
     *       "region": "PDX",
     *       "storeFamily": "IHM",
     *       "geofenceRadiusInMeters": 60,
     *       "appInactivityThresholdInSecs": 300,
     *       "storeGeocodes" : {
     *           "latitude": 47.6097971,
     *           "longitude": -122.324084
     *        }
     *      }
     *  ]
     *
     */
    public async getNearbyStores (latitude: string, longitude: string): Promise<IAuthenticatedRequestHandlerResponse> {
        return this.sendRequest({
            url: this.endpoint + 'getNearbyStores/',
            method: 'GET',
            queryParams: {
                latitude,
                longitude,
            }})
    }

    /**
     * Returns  store info.
     *
     * @param {string} storeId
     * @return {Promise} Store info. For example.
     *    {
     *       "storeId": "US-WA-20",
     *       "name": "Madison & Minor",
     *       "region": "PDX",
     *       "storeFamily": "IHM",
     *       "geofenceRadiusInMeters": 60,
     *       "appInactivityThresholdInSecs": 300,
     *       "storeGeocodes" : {
     *           "latitude": 47.6097971,
     *           "longitude": -122.324084
     *        }
     *   }
     *
     */
    public async getStoreDetailsByStoreId (storeId: string): Promise<IAuthenticatedRequestHandlerResponse> {
        return this.sendRequest({
            url: this.endpoint + 'getStoreDetailsByStoreId/',
            method: 'GET',
            queryParams: {
                storeId,
            },
        })
    }

    /**
     * Private Constructor setting the StoreSelection client and its endpoint
     * @private
     */
    private constructor () {
        this.client = StoreSelectionClient
        this.client.config.overrideDomain(EnvironmentDetail.getDomain())
        this.client.config.overrideRealm('us-west-2') // Store Selection Service is in PDX region
        const config = this.client.config.getClientConfigValue()
        this.endpoint = config.httpEndpoint.url
        console.debug('logging endpoint',this.endpoint)
    }

    /**
     * Makes the call to the abstract authenticatedRequestsClient.
     * @param options call parameters.
     * @returns {*} Output from the call (from the underlying service)
     */
    private async sendRequest (options): Promise<IAuthenticatedRequestHandlerResponse> {
        const queryParamString = this.buildQueryParamString(options.queryParams)
        options.url = options.url + queryParamString
        delete options.queryParams
        return AuthenticatedRequestHandler.raw(options)
    }

    /**
     * Converts queryParam json object to queryParam string
     */
    private buildQueryParamString (queryParams: Record<string, string>): string {
        let queryParamString = '?'
        Object.keys(queryParams).forEach((key) => {
            queryParamString = queryParamString + key + '=' + queryParams[key] + '&'
        })
        return queryParamString.slice(0, -1)
    }
}
